import { FC, useCallback } from 'react';
import { BodyText, Card, Divider, Headline, Icon } from '@servicetitan/design-system';
import classnames from 'classnames';

import { EHModule } from '../../../common/api/eh.api';
import { MultilineText } from '../../../common/components/multiline-text/multiline-text';

interface EHModuleCardProps {
    data: EHModule;
}

export const EHModuleCard: FC<EHModuleCardProps> = ({ data }) => {
    return (
        <Card hoverable sharp className="h-100">
            <Card.Section className="h-100 border-box">
                <Headline className="m-b-1 t-truncate" size="small">
                    <Icon
                        size="16"
                        className={classnames(
                            'm-r-1 c-neutral-300 border-radius-circular p-half',
                            data.iconBgColor
                        )}
                        name={data.icon}
                    />
                    {data.name}
                </Headline>
                <MultilineText height="41px" maxLines={2}>
                    <BodyText size="small">{data.description}</BodyText>
                </MultilineText>

                <Divider spacing="3" />
                <Icon name="arrow_forward" />
            </Card.Section>
        </Card>
    );
};
